import {
	breakpoint,
	Button,
	Flex,
	Image,
	scale,
	Text,
} from "@capioweb/ui-components/"
import React from "react"
import { QBankImage } from "../../@types/CapioWeb/core"
import styled from "styled-components"
import { imageBlockDataToImageProps } from "../../utils"
import { List } from "./List"

export interface Item {
	header: string
	href: string
	text: string
	date: string
}

interface LatestNewsCardProps {
	cta?: {
		href: string
		text: string
	}
	image: QBankImage
	items: Item[]
}

const StyledContainer = styled(Flex)`
	border-radius: ${scale.px(3)};

	${breakpoint("l")`
			border-top-right-radius: ${scale.px(3)};
			border-bottom-left-radius: ${scale.px(3)};		
	`}
`
const StyledImage = styled(Image)`
	border-top-left-radius: ${scale.px(3)};
	border-top-right-radius: ${scale.px(3)};

	${breakpoint("l")`
			border-top-right-radius: 0;
			border-bottom-left-radius: ${scale.px(3)};		
	`}
`

export const LatestNewsCard: React.FC<LatestNewsCardProps> = ({
	cta,
	image,
	items,
}) => {
	const srcSetSizes = [{ width: 1000, breakpoint: 2560 }]
	return (
		<StyledContainer
			backgroundColor={"blue11"}
			flexDirection={{
				_: "column",
				l: image?.media?.value?.url ? "row" : "row-reverse",
			}}
			width={"100%"}
		>
			{image?.media?.value?.url && (
				<StyledContainer w={{ _: 1, l: 0.5 }} h={{ _: 30, l: 59 }}>
					<StyledImage
						{...imageBlockDataToImageProps(image, true, true, srcSetSizes)}
					/>
				</StyledContainer>
			)}
			<Flex
				flexBasis={{ l: "50%" }}
				p={{ _: 3, l: 6.5 }}
				flexDirection={"column"}
			>
				<List>
					{items.map((item, index) => {
						return (
							<List.Item
								href={item.href}
								key={index}
								text={item.text}
								date={item.date}
							>
								<Flex flexDirection={"column"}>
									<Flex>
										<Text mb={0} mr={1} w="50%">
											{item.date?.toUpperCase()}
										</Text>
									</Flex>
									<Text fontWeight={"bold"} mb={0}>
										{item.header}
									</Text>
								</Flex>
							</List.Item>
						)
					})}
				</List>
				{cta?.href && (
					<Flex flexDirection={{ _: "column", m: "row" }} pt={{ _: 3, m: 4 }}>
						<Button.Anchor href={cta.href} variant="navy">
							{cta.text}
						</Button.Anchor>
					</Flex>
				)}
			</Flex>
		</StyledContainer>
	)
}
